import { Column } from 'react-table';
import { ContextMenuButton, TableCell, TableHeader, UserAvatar } from 'redesign';
import { TFunctionNonStrict } from 'i18next';
import { PlacementCellProps, PlacementColumnDefinition } from './placements-table.types';
import { getFlexWorkerLabel } from '../../../../../../utils/get-flex-worker-label';

export const getPlacementsColumnDefinition = (
  t: TFunctionNonStrict<'hq-screen-specific', undefined>
) => {
  const flexWorkerImage: Column<PlacementColumnDefinition> = {
    Header: '',
    accessor: 'flexWorkerAvatar',
    Cell: FlexWorkerImageCell,
  };

  const fw: Column<PlacementColumnDefinition> = {
    Header: () => (
      <TableHeader>
        {t('projects.placements.table_headers.flexworker', { ns: 'hq-screen-specific' })}
      </TableHeader>
    ),
    accessor: 'flexWorker',
    Cell: ({ value }) => <TableCell>{value}</TableCell>,
  };

  const email: Column<PlacementColumnDefinition> = {
    Header: () => (
      <TableHeader>
        {t('projects.placements.table_headers.email', { ns: 'hq-screen-specific' })}
      </TableHeader>
    ),
    accessor: 'email',
    Cell: ({ value }) => <TableCell>{value}</TableCell>,
  };

  const phone: Column<PlacementColumnDefinition> = {
    Header: () => (
      <TableHeader>
        {t('projects.placements.table_headers.phone', { ns: 'hq-screen-specific' })}
      </TableHeader>
    ),
    accessor: 'phone',
    Cell: ({ value }) => <TableCell>{value}</TableCell>,
  };

  const actions: Column<PlacementColumnDefinition> = {
    Header: '',
    accessor: 'actions',
    Cell: ActionCell,
  };

  return [flexWorkerImage, fw, email, phone, actions];
};

const FlexWorkerImageCell = ({ value, onProfileClick }: PlacementCellProps<'flexWorkerAvatar'>) => {
  const { id, firstName, lastName, relation, imageUrl, employmentType } = value;
  const avatarLabel = getFlexWorkerLabel(employmentType);

  return (
    <UserAvatar
      onClick={() => onProfileClick(id, relation)}
      firstName={firstName}
      lastName={lastName}
      imageUrl={imageUrl}
      avatarLabel={avatarLabel}
    />
  );
};

const ActionCell = ({ value, getRowActions }: PlacementCellProps<'actions'>) => {
  const actions = getRowActions(value);

  if (actions.length === 0) {
    return null;
  }

  return (
    <ContextMenuButton menuId={`placements-actions-menu-${value.placement.flexWorker.id}`}>
      {actions}
    </ContextMenuButton>
  );
};
